module.exports = __webpack_public_path__ + "static/assets/59d7fa2d735a01696fff358723eb2be9.svg";